/// <reference types='google.maps' />
import {
  JobModel,
  PointModel,
  PositionDetailModel,
  PositionListenerModel,
  VehicleModel,
} from '@fleet/model';

export function positionListenerModelFromVehicle(vehicle: VehicleModel) {
  const lm = {} as PositionListenerModel;
  if (vehicle?.vehicleId) {
    lm.vehicleIds = [vehicle.vehicleId];
  }
  if (vehicle.networkId) {
    lm.networkId = vehicle.networkId;
  }
  if (vehicle.networkGroupId) {
    lm.networkGroupId = vehicle.networkGroupId;
  }
  return lm;
}

export function positionDetailFromVehicle(
  vehicle: VehicleModel
): PositionDetailModel | null {
  if (!vehicle?.vehicleId || !vehicle.position) {
    return null;
  }
  return {
    vehicleId: vehicle.vehicleId,
    driverId: '',
    travellerId: '',
    availability: '',
    plateNumber: vehicle.plate?.plateNumber ?? '',
    appStatus: '',
    vdsStatus: '',
    locality: '',
    distance: 0,
    distanceUnit: '',
    position: vehicle.position,
  } as PositionDetailModel;
}

/** Minimal listener payload so MapService can draw a single vehicle from getVehicle position. */
export function initialPositionListenerFromVehicle(
  vehicle: VehicleModel
): PositionListenerModel | null {
  const detail = positionDetailFromVehicle(vehicle);
  if (!detail) {
    return null;
  }
  return {
    ...positionListenerModelFromVehicle(vehicle),
    positions: [detail],
    delta: false,
  } as PositionListenerModel;
}

export function positionListenerModelFromJobModel(job: JobModel) {
  const lm = {} as PositionListenerModel;
  if (job.vehicle) {
    lm.vehicleIds = [job.vehicle.vehicleId];
  }
  if (job.network) {
    lm.networkId = job.network.attributionNetworkId;
    if (job.network.attributionNetworkGroupId) {
      lm.networkGroupId = job.network.attributionNetworkGroupId;
    }
  }
  return lm;
}

export function boundsFromJob(job: JobModel) {
  const bounds = new google.maps.LatLngBounds();
  if (job.jobDetail.startLocation) {
    bounds.extend({
      lat: +job.jobDetail.startLocation.latitude,
      lng: +job.jobDetail.startLocation.longitude,
    });
  }
  if (job.jobDetail.endLocation && job.jobDetail.endLocation.latitude) {
    bounds.extend({
      lat: +job.jobDetail.endLocation.latitude,
      lng: +job.jobDetail.endLocation.longitude,
    });
  }

  if (job.jobProgress && job.jobProgress.position) {
    bounds.extend({
      lat: +job.jobProgress.position.latitude,
      lng: +job.jobProgress.position.longitude,
    });
  }
  return bounds;
}

export function pointModelFromLatLngLiterial(latLng: google.maps.LatLng) {
  return {
    latitude: latLng.lat().toString(),
    longitude: latLng.lng().toString(),
  } as PointModel;
}

export function latLngFromPointModel(point: PointModel) {
  return new google.maps.LatLng(+point.latitude, +point.longitude);
}
